"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setIndicator = void 0;

var setIndicator = function setIndicator(indicators, index) {
  indicators.current.childNodes.forEach(function (i) {
    return i.classList.remove("active");
  });
  indicators.current.children[index].classList.add("active");
};

exports.setIndicator = setIndicator;